export interface IClientDetailTbl {
	clientId: number;
	clientName?: string;
	isActiveStr?: string;
	isUpdatedOffline: boolean;
	canDelete: boolean;
};

export class ClientDetailTbl implements IClientDetailTbl {
	clientId = 0;
	clientName = '';
	isActiveStr = '';
	isUpdatedOffline = false;
	canDelete = false;
};
